import React, { useState } from "react";
import "./AboutLessons.css";

import { LessonDetails } from "../../Components/LessonDetails/LessonDetails";

import Beginners from "../../images/beginners.jpg";
import Intermediate from "../../images/intermediate.jpg";
import Advanced from "../../images/advanced.jpg";

const lessons = [
  {
    id: 1,
    title: "Principiante",
    objective: "Introducción al surf y familiarización con el mar.",
    pointsToLearn: [
      "Conocer el equipo de surf (tabla, leash, etc.)",
      "Seguridad básica dentro del agua",
      "Cómo remar correctamente",
      "Cómo posicionarse en la tabla",
      "Técnica básica para ponerse de pie (pop-up)",
    ],
    quote: "Ideal para quienes nunca han surfeado o están empezando.",
    thumbnails: [
      {
        title: "Principiante",
        img: Beginners,
      },
    ],
  },
  {
    id: 2,
    title: "Intermedio",
    objective: "Tomar olas por cuenta propia y empezar a leer el mar.",
    pointsToLearn: [
      "Cómo posicionarse correctamente en el line-up",
      "Identificar picos y tipos de olas",
      "Timing para remar y tomar olas",
      "Mejora de técnica de remo y pop-up",
      "Primeros giros (bottom turn, trimming)",
      "Reglas dentro del agua",
    ],
    quote: "Para quienes ya logran pararse y quieren progresar.",
    thumbnails: [
      {
        title: "Intermedio",
        img: Intermediate,
      },
    ],
  },
  {
    id: 3,
    title: "Avanzado",
    objective:
      "Pulir técnica y llevar el surf a un nivel más alto, según necesidades.",
    pointsToLearn: [
      "Lectura avanzada de olas y condiciones del mar",
      "Maniobras como cutbacks, snaps, floaters",
      "Posicionamiento estratégico y selección de olas",
      "Análisis de video (si aplica)",
      "Preparación física y mental para mejorar rendimiento",
    ],
    quote: "Ideal para surfistas que buscan evolucionar su estilo.",
    thumbnails: [
      {
        title: "Avanzado",
        img: Advanced,
      },
    ],
  },
];

export const AboutLessons = () => {
  const [selectedLesson, setSelectedLesson] = useState(lessons[0]);

  const handleLessonClick = (lessonIndex) => {
    setSelectedLesson(lessons[lessonIndex]);
  };

  return (
    <section className="about-lessons">
      <LessonDetails lesson={selectedLesson} />
      <div className="about-lessons__thumbnails">
        {lessons.map((lesson, index) => (
          <div
            key={lesson.id}
            className="thumbnail"
            backgroundImage={lesson.thumbnails[0]?.img}
            style={{
              backgroundImage: lesson.thumbnails[0]?.img,
            }}
            onClick={() => handleLessonClick(index)}
          >
            <img src={lesson.thumbnails[0]?.img} alt="" />
            <div className="thumbnail__title">{lesson.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
